module.exports = __webpack_public_path__ + "ir.svg?28b0fb3b3d83de326b81a1668e21beb6";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/ir.svg
// module id = 1169
// module chunks = 0